import Entities from "./shared/Entities";

export default class CustomScrollbar {
  constructor() {
    this.entities = new Entities("CustomScrollbar", "[data-custom-scroll]", CustomScrollbar.initSingle, CustomScrollbar.destroySingle);
  }

  static initSingle(containerEl) {
    const content = containerEl.querySelector("[data-container]");
    const track = containerEl.querySelector("[data-track]");
    const btnUp = containerEl.querySelector("[data-button-up]");
    const btnDown = containerEl.querySelector("[data-button-down]");

    if (!content || !track) return;

    content.addEventListener(
      "wheel",
      (e) => {
        const atTop = content.scrollTop === 0;
        const atBottom = content.scrollTop + content.clientHeight >= content.scrollHeight;

        if ((e.deltaY < 0 && atTop) || (e.deltaY > 0 && atBottom)) {
          e.preventDefault();
        }
      },
      { passive: false },
    );

    const thumb = track.querySelector("::after"); // ❌ nie działa w JS
    // więc będziemy sterować przez style CSS variable

    const thumbEl = track; // użyjemy CSS var na tracku

    // 🔥 UPDATE THUMB
    function update() {
      const contentHeight = content.scrollHeight;
      const visibleHeight = content.clientHeight;

      const ratio = visibleHeight / contentHeight;

      const trackHeight = track.clientHeight;

      const thumbHeight = Math.max(trackHeight * ratio, 20); // min height
      const scrollRatio = content.scrollTop / (contentHeight - visibleHeight);

      const maxMove = trackHeight - thumbHeight;
      const top = scrollRatio * maxMove;

      // ustawiamy przez CSS vars
      track.style.setProperty("--thumb-height", `${thumbHeight}px`);
      track.style.setProperty("--thumb-top", `${top}px`);

      // disable buttons
      if (btnUp) btnUp.disabled = content.scrollTop <= 0;
      if (btnDown) btnDown.disabled = content.scrollTop >= contentHeight - visibleHeight - 1;
    }

    // 🖱 SCROLL (myszka działa naturalnie)
    content.addEventListener("scroll", update);

    // 🔘 BUTTONS
    btnUp?.addEventListener("click", () => {
      content.scrollBy({ top: -100, behavior: "smooth" });
    });

    btnDown?.addEventListener("click", () => {
      content.scrollBy({ top: 100, behavior: "smooth" });
    });

    let raf;

    function startScrollFn(dir) {
      function step() {
        content.scrollTop += dir * 10;
        raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }

    function stopScroll() {
      cancelAnimationFrame(raf);
    }

    btnUp?.addEventListener("mousedown", () => startScrollFn(-1));
    btnDown?.addEventListener("mousedown", () => startScrollFn(1));
    document.addEventListener("mouseup", stopScroll);

    // 🖱 DRAG THUMB
    let isDragging = false;
    let startY = 0;
    let startScroll = 0;

    // DRAG (fake, bo używamy track jako referencji)
    track.addEventListener("mousemove", (e) => {
      if (!isDragging) return;

      const delta = e.clientY - startY;
      const ratio = content.scrollHeight / track.clientHeight;

      content.scrollTop = startScroll + delta * ratio;
    });

    track.addEventListener("mousedown", (e) => {
      isDragging = true;
      startY = e.clientY;
      startScroll = content.scrollTop;

      const rect = track.getBoundingClientRect();
      const clickY = e.clientY - rect.top;

      const ratio = content.scrollHeight / track.clientHeight;
      content.scrollTop = clickY * ratio;

      document.body.style.userSelect = "none";
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
      document.body.style.userSelect = "";
    });

    // INIT
    update();

    // RESIZE
    window.addEventListener("resize", update);

    function destroy() {
      content.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      document.removeEventListener("mouseup", stopScroll);
    }

    return { destroy };
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
